<template>
  <ListPane :getListMethod="getMachineListFromFilter" :optional-filters="filters" :paginationEnabled="true"
    :show-filter-tab="true" :show-sorting-tab="true" :itemsPerPage="100" :lockedFilters="lockedFilters"
    :set-preview-function="openPreview" :open-function="openItem" :dialog-trigger="dialogtrigger" :dialogItem="editItem"
    :dialog-method-config="dialogMethodConfig" :pk="pk" ref="ListPane" :exportFunction="exportFunc">
    <template v-slot:list-item="{ item, handlechanged }">
      <ListItem :machine="item" :isSelected="$route.query.machineId == item.Id" :inspectable="true"
        :preselected="multiSelectList.map(x => x.Id)" :show-checkbox="false" :showHasBeenSelected="false"
        :invertPreview="true" @checked="e => toggleItem(e, item)" @select="openItem(item)"
        @openPreview="openPreview(item)" @closePreview="closePreview()" @Update="handlechanged"
        :compact="compact">
      </ListItem>
    </template>

    <template v-slot:dialog-content="{ item, trigger }">
      <MachineCustomerEditContent :key="'ggg-' + trigger" :editItem="item" :editMode="true" :handleFocus="() => { }"
        class="mt-3">
      </MachineCustomerEditContent>
      <h4 v-text="$t('servicesystem.common_objects.machine.product')" class="px-3" />
      <MachineProductEditContent :key="'lll-' + trigger" :editItem="item" :editMode="true" :handleFocus="() => { }">
      </MachineProductEditContent>
      <h4 v-text="$t('servicesystem.common_objects.commonterms.details')" class="px-3" />
      <MachineDetailsEditContent :key="'jjj-' + trigger" :editItem="item" :editMode="true" :handleFocus="() => { }">
      </MachineDetailsEditContent>
    </template>

  </ListPane>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ListItem from "@/components/ListItems/MachineListItem.vue";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import MachineCustomerEditContent from "@/views/admin/machines/MachineCustomerEditContent.vue";
import MachineDetailsEditContent from "@/views/admin/machines/MachineDetailsEditContent.vue";
import MachineProductEditContent from "@/views/admin/machines/MachineProductEditContent.vue";

export default {
  name: "MachineListPane2",
  props: {
    pk: String,
    lockedFilters: Object,
    compact: Boolean,
  },
  components: {
    ListPane,
    ListItem,
    MachineDetailsEditContent,
    MachineProductEditContent,
    MachineCustomerEditContent,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data: () => ({
    toggleSelect: false,
    multiactions: ['change owner for', 'change model for', 'disable', 'open in new tabs'],
    multiaction: null,
    multiSelectList: [],

    editItem: null,
    dialogtrigger: 1,
    dialogMethodConfig: {
      Create: {
        IsClientApiMethod: true,
        Name: 'createMachine',
      },
    },
  }),

  methods: {
    exportFunc(filters) {
      //console.log("exporting machines", filters);
      clientAPI.methods.exportMachineListFromFilter(filters);
    },

    handleadded(item) {
      this.$refs.ListPane.handleadded(item);
    },
    handlechanged(item) {
      this.$refs.ListPane.handlechanged(item);
    },

    setEditItem(item) {
      this.editItem = item;
      this.dialogtrigger++;
    },

    newEditItem() {
      var customerId = this.lockedFilters?.CustomerId ?? null;
      var machineModelId = this.lockedFilters?.MachineModelIdList?.[0] ?? null;
      var machineTypeId = this.lockedFilters?.MachineTypeIdList?.[0] ?? null;
      var supplierId = this.lockedFilters?.SupplierIdList?.[0] ?? null;
      var obj = {
        Id: 0,
        CustomerId: customerId,
        MachineModel: machineModelId ? { Id: parseInt(machineModelId) } : undefined,
        MachineType: machineTypeId ? { Id: parseInt(machineTypeId) } : undefined,
        Supplier: supplierId ? { Id: parseInt(supplierId) } : undefined,
        FirmId: this.userInfo.FirmId,
      };
      //console.log("newEditItem", obj);
      this.setEditItem(obj);
    },

    openPreview(item) {
      if (this.$route.query.machineId != item.Id) {
        var query = Object.assign({}, this.$route.query);
        query.machineId = item.Id;
        this.$router.replace({ query });
        if (this.isPhoneBool) { this.$store.state.triggerevents.previewTrigger++; }
      }
    },

    openItem(item) {
      var query = (this.$route.name == "MachineList") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'ViewMachine', params: { machineId: item.Id }, query })
    },

    closePreview() {
      if (this.$route.query.machineId != undefined) {
        var query = Object.assign({}, this.$route.query);
        query.machineId = undefined;
        this.$router.replace({ query });
        if (this.isPhoneBool) { this.$store.state.triggerevents.previewTrigger++; }
      }
    },

    toggleItem(b, item) {
      if (b) {
        this.multiSelectList.push(item);
      }
      else {
        this.multiSelectList = this.multiSelectList.filter(x => x.Id != item.Id);
      }
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          SupplierIdList: this.getQueryParam("filter-suppliers", []),
          MachineTypeIdList: this.getQueryParam("filter-types", []),
          MachineModelIdList: this.getQueryParam("filter-models", []),
          AssetTypeIdList: this.getQueryParam("filter-asset-types", []),
          CustomerId: this.getQueryParam("filter-customer", ""),
          //ParentCustomerId: this.getQueryParam("filter-parentcustomer", ""),
          //CustomerGroupId: this.getQueryParam("filter-customergroup", ""),
          ServiceAgreementState: this.getQueryParam("filter-serviceagreement", 0),
          Sort: this.getQueryParam("filter-sorting", []),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },
  },

  watch: {
    externaltrigger: function () { this.newEditItem(); }
  },
};
</script>


<style lang="scss" scoped></style>